import { TimeSeries, TimeSeriesImpl } from "firefly-shared-ts-timeseries";
import { merge } from "lodash";
import { YAxis } from "@mui/x-charts-premium";

const defaultWidth = 50;

export const resolveYAxisConfig = (
  timeSeries: Array<TimeSeries<number | null>>,
  axisConfigs?: Array<YAxis<"linear">>
): Array<YAxis<"linear">> => {
  if (timeSeries.length === 0) {
    return [
      {
        max: 100,
        width: defaultWidth,
      } as YAxis<"linear">,
    ];
  }

  const firstTimeSeries = timeSeries.length > 0 ? timeSeries[0] : undefined;

  return (
    axisConfigs?.map((givenConfig) => {
      const max =
        givenConfig.max != null && typeof givenConfig.max === "number"
          ? givenConfig.max
          : (TimeSeriesImpl.getMaxY(timeSeries, 0) ?? 0) + 20;

      const valueFormatter =
        givenConfig.valueFormatter != null
          ? givenConfig.valueFormatter
          : firstTimeSeries !== undefined
          ? (value: number) => `${value} ${firstTimeSeries.info.unit}`
          : undefined;

      return merge(
        {
          max: max,
          valueFormatter: valueFormatter,
          width: defaultWidth,
        } as YAxis<"linear">,
        givenConfig
      );
    }) ?? [
      {
        max: (TimeSeriesImpl.getMaxY(timeSeries, 0) ?? 0) + 20,
        width: defaultWidth,
      } as YAxis<"linear">,
    ]
  );
};
